"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var Localize_1 = require("../../gen-src/Localize");
function formatLastUpdatedDate(date) {
    var day = moment(date).format('MMM D');
    var time = moment(date).format('h:mmA');
    return Localize_1.Messages.syncedAtTime({ day: day, time: time });
}
exports.formatLastUpdatedDate = formatLastUpdatedDate;
function formatSelectedDisplayDate(timestamp) {
    var date = moment(timestamp).format('MMMM D, YYYY');
    return Localize_1.Messages.selectedDate({ date: date });
}
exports.formatSelectedDisplayDate = formatSelectedDisplayDate;
// TODO Localization support for metrics
var scaleSymbols = ['', 'K', 'M', 'B', 'T'];
function formatTimestampedMeasureAsMetricNumber(value) {
    return formatValueAsMetricNumber(value !== undefined ? value.measure : undefined);
}
exports.formatTimestampedMeasureAsMetricNumber = formatTimestampedMeasureAsMetricNumber;
function formatValueAsMetricNumber(value) {
    return formatMetricValueForDisplay(value);
}
exports.formatValueAsMetricNumber = formatValueAsMetricNumber;
function formatMetricValueForDisplay(value) {
    if (value === undefined) {
        return '';
    }
    // Format with digit separators and round to 2 decimal places.
    var scaledNumber = scaleNumber(value);
    var scaledValueForDisplay = Localize_1.Formatters.formatTwoDecimalPlaces(scaledNumber[0]) + scaledNumber[1];
    return scaledValueForDisplay;
}
function scaleNumber(value) {
    // Use the absolute value when determining the scale of the number
    var absValue = Math.abs(value);
    if (absValue < 10000 && (absValue % 1 === 0)) {
        // The raw number looks better than the scaled version
        return [value, ''];
    }
    // What is the order of magnitude?  Max is 4 because of length of symbol list.
    // tslint:disable-next-line:no-bitwise
    var orderOfMagnitude = Math.min((Math.log10(absValue) / 3) | 0, 4);
    // Get suffix and determine scale
    var suffix = scaleSymbols[orderOfMagnitude];
    var scale = Math.pow(10, orderOfMagnitude * 3);
    // Scale the original number (not the absolute value)
    var scaled = value / scale;
    // Return the scaled number and suffix
    return [scaled, suffix];
}
//# sourceMappingURL=formatting.js.map